import React, { ReactNode } from "react";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import ClipLoader from "react-spinners/ClipLoader";
import ApiFailed from '../../Utils/ApiFailed';
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import { DataGrid, Column, SortByGroupSummaryInfo, GroupItem, Summary} from 'devextreme-react/data-grid';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import { withStyles, createStyles } from '@mui/styles';

const styles: Record<any, any> = {
    formControl: {
        minWidth: 120,
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        color: "#FFFFFF",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

const style = createStyles(styles);

interface Region {
    id: number;
    name: string;
    from: string;
    generation: number;
}

interface Props {
    classes: {
        cardTitleWhite: string;
    };
    groupId: number;
    regionOptions: { value: number; label: string }[];
}

interface State {
    loading: boolean;
    tableHidden: boolean;
    authorized: boolean;
    regions: Region[];
    clickRegion: Region | null;
    anchorEl: HTMLElement | null;
}

class RegionsPanel extends React.Component<Props, State> {
    gridRef: React.RefObject<DataGrid>;
    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {
            loading: true,
            tableHidden: true,
            authorized: true,
            regions: [],
            clickRegion: null,
            anchorEl: null
        };

        this.gridRef = React.createRef();

    }

    componentDidMount(): void {
        //get detail on logger here
        const me = this;

        CallGetAPI(CreateUrl('/api/aquaguard/GetAllRegionsForGroup?groupid=' + me.props.groupId),{})
            .then(data => {
                const regions: Array<Region> = [];
                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        const region: Region = {
                            id: data[i].id,
                            name: me.props.regionOptions.filter(r => r.value == data[i].memberId)[0].label,
                            from: data[i].groupName,
                            generation: data[i].generation,
                        }
                        regions.push(region);
                    }
                }

                me.setState({
                    regions: regions
                });

            })
            .catch(function () {
                me.setState(
                    {
                        authorized: false,
                    })
            });

        this.setState({ loading: false, tableHidden: false });
    }

    moreRender(key: any): React.ReactNode {
        return (
            <IconButton size="small" onClick={(e: React.MouseEvent<HTMLElement>): void => { this.handleClick(e, key.key); }}><MoreHorizIcon /></IconButton>
        );
    }

    handleClick(event: React.MouseEvent<HTMLElement>, id: number): void {
        this.setState(
            {
                clickRegion: this.state.regions.filter( r => r.id == id)[0],
                anchorEl: event.currentTarget
            });
    }

    render(): ReactNode {

        return (

            <div>
                {this.state.loading &&
                    <div style={{
                        position: 'absolute', left: '50%', top: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <ClipLoader
                            size={150}
                            color={"#123abc"}
                            loading={this.state.loading}
                        />
                    </div>
                }
                {!this.state.loading &&
                    <div>
                        {this.state.tableHidden &&
                                <ApiFailed />
                        }
                    {!this.state.tableHidden &&
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                            <div>
                                <DataGrid
                                    dataSource={this.state.regions}
                                    ref={this.gridRef}
                                    key="id" >

                                    <Column dataField="id" visible={false} dataType="string" />
                                    <Column dataField="name" visible={true} dataType="string" />
                                    <Column dataField="from" visible={true} dataType="string" groupIndex={0} />

                                    <Summary>
                                        <GroupItem
                                            column="generation"
                                            summaryType="min"
                                            displayFormat="Level: {0}"
                                            showInColumn={true}
                                        />
                                    </Summary>
                                    <SortByGroupSummaryInfo
                                        summaryItem={0}
                                        sortOrder="asc"
                                    />
                                </DataGrid>
                            </div>

                            </GridItem>
                        </GridContainer>

                    }
                    </div>
                }

            </div>

        )
    }

}

export default withStyles(style)(RegionsPanel);